import React, { useEffect, useState } from "react"

import "./LoginAuth.scss"


interface LoginAuthProps {
  children: React.ReactNode
}


const LoginAuth = ({
  children,
}: LoginAuthProps) => {

  const [authenticated, setAuthenticated] = useState(false)
  const [initialized, setInitialized] = useState(false)
  const [password, setPassword] = useState("")


  const isStaging =
    process.env.GATSBY_ENV === "staging"


  useEffect(() => {

    if (!isStaging) {
      return
    }


    const access =
      window.localStorage.getItem(
        "staging-auth"
      )


    if (access === "true") {
      setAuthenticated(true)
    }


    setInitialized(true)

  }, [isStaging])


  const handleLogin = (
    event: React.FormEvent
  ) => {

    event.preventDefault()


    if (
      password ===
      process.env.GATSBY_STAGING_PASSWORD
    ) {

      window.localStorage.setItem(
        "staging-auth",
        "true"
      )

      setAuthenticated(true)

      return
    }


    alert("Wrong password")

  }


  /*
    IMPORTANT:

    Production must render the page during SSR.
    This allows Gatsby to generate complete
    static HTML for SEO and Netlify Forms.
  */
  if (!isStaging) {

    return (
      <>
        {children}
      </>
    )

  }


  /*
    Staging:
    wait until localStorage has been checked.
  */
  if (!initialized) {

    return (
      <div className="login-auth-placeholder" />
    )

  }


  /*
    Staging:
    authenticated users can access the site.
  */
  if (authenticated) {

    return (
      <>
        {children}
      </>
    )

  }


  /*
    Staging:
    login screen.
  */
  return (

    <main className="login-auth">

      <form
        onSubmit={handleLogin}
        className="login-auth__form"
      >

        <h1>
          Login
        </h1>


        <p>
          This site is private.
        </p>


        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(event) =>
            setPassword(event.target.value)
          }
        />


        <button type="submit">
          Enter
        </button>

      </form>

    </main>

  )

}


export default LoginAuth